import { useEffect, useState } from "react";
import { SmallModal } from "../../../../../../components/smallModal";
import { api } from "../../../../../../services/api";
import { SpaceLoader } from "../../../../../../components/loaders/spaceLoader";
import { Wrap } from "./style";
import moment from "moment/moment";

export function ChoseTime({ date, cdEmpresa, setCurrentStep, handleChose }) {
	const [times, setTimes] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		api
			.get("getSchedulesOrdersByDay", {
				params: {
					idBusiness: cdEmpresa,
					currentDate: date,
				},
			})

			.then(({ data }) => {
				if (moment(date).format("DD/MM/yyyy") === moment(new Date()).format("DD/MM/yyyy")) {
					const availableTimes = [];

					for (const time of data.results) {
						if (moment(new Date()).format("HH:mm") <= time.NovoHorario) {
							availableTimes.push(time);
						}
					}

					setTimes(availableTimes);
				} else {
					setTimes(data.results);
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [cdEmpresa, date]);

	return (
		<SmallModal title="Escolha um horário" toClose={() => setCurrentStep("date")}>
			<div>
				{isLoading ? (
					<>
						<SpaceLoader />
					</>
				) : (
					<>
						{!times.length && <p>Não há horários disponíveis</p>}
						{times.map((time, index) => (
							<Wrap key={index}>
								<p>{time.NovoHorario}</p>
								{time.hasLimit && <p>disponíveis: {time.pedidosDisponiveis}</p>}
								<button
									type="button"
									disabled={time.pedidosDisponiveis === 0 && time.hasLimit}
									onClick={() => {
										setCurrentStep("time");
										handleChose(time.NovoHorario);
									}}
								>
									Selecionar
								</button>
							</Wrap>
						))}
					</>
				)}
			</div>
		</SmallModal>
	);
}
